<script setup>
/**
 * The container for settings pages that own their own header.
 *
 * The older settings container padded its child and capped it at `max-w-5xl`,
 * which was right for the old card stack but wrong for a `SettingsPageShell`:
 * the shell's header bar has to run edge to edge and stay put while the body
 * scrolls under it. This wrapper does nothing but hand the page the full pane.
 */
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const route = useRoute();
</script>

<template>
  <div class="flex flex-col w-full h-full min-w-0 bg-n-background">
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
      <component :is="Component" v-else :key="route.fullPath" />
    </router-view>
  </div>
</template>
